import { render } from "./MScope.vue?vue&type=template&id=1e2b29e8&scoped=true"
import script from "./MScope.vue?vue&type=script&lang=js"
export * from "./MScope.vue?vue&type=script&lang=js"

import "./MScope.vue?vue&type=style&index=0&id=1e2b29e8&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\ms\\ms-by-bimms\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e2b29e8"]])

export default __exports__